export default {
    searchBy: 'ค้นหาด้วยชื่อวันหยุด',
    search: 'ค้นหา',
    addGroupHoliday: 'สร้างวันหยุดเฉพาะกลุ่ม',
    groupHolidayName: 'ชื่อวันหยุด',
    holiday: 'วันที่หยุด',
    dateCreate: 'วันที่สร้าง',
    forGroup: 'สำหรับกลุ่ม',
    description: 'คำอธิบาย',
    deleteGroup: 'ลบวันหยุดเฉพาะกลุ่ม',
    congratulation: 'ยินดีด้วย',
    msgDeleteSuccess: 'วันหยุดเฉพาะกลุ่มถูกลบเเล้ว',
    questionDelete: 'คุณเเน่ใจว่าต้องการที่จะลบวันหยุดเฉพาะ "$Name" ?',
    companyHoliday: 'วันหยุดบริษัท'
}
